import { ConditionOperator, ConditionParameter, PermissionsResources } from '@ibk/shared-types';
export const getTransactionLimitConditions = (transactionLimit) => {
    const transactionCondition = {
        parameter: ConditionParameter.AMOUNT,
        condition: ConditionOperator.LE,
        value: String(transactionLimit),
    };
    return {
        [PermissionsResources.INSTRUCTION_APPROVE_PIX_OUT]: [transactionCondition],
        [PermissionsResources.INSTRUCTION_APPROVE_BANKSLIP]: [transactionCondition],
        [PermissionsResources.INSTRUCTION_APPROVE_SCHEDULED_BANKSLIP]: [transactionCondition],
        [PermissionsResources.INSTRUCTION_APPROVE_SCHEDULED_PIX]: [transactionCondition],
    };
};
